import React, { useState, useEffect } from "react";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import axios from "../../../../node_modules/axios/index";
import { toast } from "react-toastify";

const CustomizedSwitches = ({ organization, onToggle }) => {
  const [isActive, setIsActive] = useState(organization.isActive);

  useEffect(() => {
    if (organization) {
      setIsActive(organization.isActive);
    }
  }, [organization]);

  const handleToggle = async (orgId, isactive) => {
    const statusPayload = { isActive: isactive };
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/V1/admin/organization/organizationStatus/${orgId}`,
      statusPayload,
      {
        headers: {
          "Content-Type": "application/json"
        },
      }
    );
    setIsActive(!isActive);
    if (response.data.success) {
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      if (onToggle) {
        onToggle();
      }
    } else {
      toast.error(response.data.message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <FormGroup>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>{isActive ? "Active" : "Deactive"}</Typography>
        <Switch
          checked={isActive}
          onClick={() => {
            handleToggle(organization._id, !isActive);
          }}
          inputProps={{ "aria-label": "ant design" }}
        />
      </Stack>
    </FormGroup>
  );
};

export default CustomizedSwitches;
